import React from 'react';

import {type PageInitConfig, useLocation, usePageInit} from 'coreHooks';

import {ProductDetailProvider} from './context/ProductDetailContext';
import ProductDetailBase from './ProductDetailBase';

type ProductDetailPageProps = {
	pid: string;
	variationGroupId: string;
	isRequiresLoginForRegisteredBannedA?: boolean;
	seo: PageInitConfig['seo'];
};

/**
 * The product page of `ProductDetailRoute` and `ProductDetailApi`, mounted only for a product found: a
 * PageNotFound dispatches its own route.
 */
const ProductDetailPage = ({pid, variationGroupId, isRequiresLoginForRegisteredBannedA, seo}: ProductDetailPageProps) => {
	const location = useLocation();
	// Not part of the page queries: their keys do not hold the query string.
	const searchParams = location.search?.startsWith('?') ? location.search.slice(1) : location.search;

	usePageInit({
		route: `Product-Show?pid=${pid}${searchParams ? `&${searchParams}` : ''}`,
		isHomePage: false,
		seo,
	});

	return (
		<ProductDetailProvider>
			<ProductDetailBase
				pid={pid}
				variationGroupId={variationGroupId}
				isRequiresLoginForRegisteredBannedA={isRequiresLoginForRegisteredBannedA}
			/>
		</ProductDetailProvider>
	);
};

export default ProductDetailPage;
